// extracted by mini-css-extract-plugin
module.exports = {"containerAuthor":"Modal_containerAuthor__JTnvz","CloseButton":"Modal_CloseButton__Jl_a_","responseModal":"Modal_responseModal__RQJ3m"};